import Isotope from 'isotope-layout';

export default class EventFilter {
    constructor (selector) {
        this.selector = selector;
        this.selectedCategories = [];
        this.query = '';

        if (!$(this.selector).length) {
            return;
        }

        // Init isotope
        this.isotope = new Isotope(this.selector, {
            itemSelector: '.event'
        });

        // Bind events
        $('.search-bar').keyup(ev => this.changeQuery(ev.target.value));
    }

    changeQuery (text) {
        this.query = text;
        this.filter();
    }

    textFilter (item) {
        const itemText = item.dataset.content.toLocaleLowerCase();
        return (
            itemText.includes(this.query.toLocaleLowerCase())
        );
    }

    filter () {
        this.isotope.arrange({
            filter: (index, itemElem) => {
                const matchesSearch = this.textFilter(itemElem);
                return !this.query || matchesSearch;
            }
        });
    }
}
